module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery8-07e6a89436d893f7444a9117bb5cb475.jpg";